/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationSettingsResponse } from '../../models/location-settings-response';

export interface GetLocationSettings$Params {
  location_id: string;
}

export function getLocationSettings(http: HttpClient, rootUrl: string, params: GetLocationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, getLocationSettings.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationSettingsResponse>;
    })
  );
}

getLocationSettings.PATH = '/locations/{location_id}/settings';
